import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'clipNumber'
})
export class ClipNumberPipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
